<div class="maintenance-page w-100">
  <div class="maintenance-container">
    <img [src]="'logos/logo.svg' | contentAssetImage" alt="OKC Thunder" class="maintenance-logo" />
    <div class="maintenance-card bg-white text-center">
      <span class="material-symbols-outlined maintenance-icon text-primary">engineering</span>
      <h3 class="maintenance-title font-heading text-primary text-uppercase mb-0">
        {{ 'maintenancepage.title' | translate : { fgbdefault: "We'll be back soon" } }}
      </h3>
      <p class="font-size-14 text-black mb-0"
        [innerHTML]="'maintenancepage.currentlyunavailable.text' | translate | markdownTranslate">
      </p>
    </div>
  </div>
</div>
